import type { FC } from 'react';
import type { Theme } from '@material-ui/core';
import type { SxProps } from '@material-ui/system';
import logo from '../res/img/partener-tecnici.png';

interface LogoProps {
  sx?: SxProps<Theme>;
}
const LogoTecnici: FC<LogoProps> = (props) => (
  <div>
    <img src={logo} width="150" height="130"/>
  </div>
);

export default LogoTecnici;
